export const UNKNOWN_DOCUMENT_TYPE_LABEL = 'Tipo não informado';
export const UNKNOWN_DOCUMENT_SUBTYPE_LABEL = 'Subtipo não informado';

const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  COMPROVANTE_DE_RENDA: 'Comprovante de Renda',
  COMPROVANTE_DE_RESIDENCIA: 'Comprovante de Residência',
  DOCUMENTO_DE_IDENTIFICACAO: 'Documento de Identificação',
  ESTADO_CIVIL: 'Estado Civil',
  IDENTIFICATION: 'Documento de Identificação',
  IDENTIFICACAO: 'Documento de Identificação',
  INCOME_PROOF: 'Comprovante de Renda',
  MARITAL_STATUS: 'Estado Civil',
  RENDA: 'Comprovante de Renda',
  RESIDENCE_PROOF: 'Comprovante de Residência',
  RESIDENCIA: 'Comprovante de Residência',
};

const DOCUMENT_SUBTYPE_LABELS: Record<string, string> = {
  CARTEIRA_FUNCIONAL_PROFISSIONAL: 'Carteira Funcional Profissional',
  CERTIDAO_CASAMENTO: 'Certidão de Casamento',
  CERTIDAO_CASAMENTO_AVERBACAO_DIVORCIO: 'Certidão de Casamento com Averbação de Divórcio',
  CERTIDAO_UNIAO_ESTAVEL: 'Certidão de União Estável',
  CIN: 'CIN',
  CNH: 'CNH',
  CONTA_CONSUMO_AGUA: 'Conta de Consumo (Água)',
  CONTA_CONSUMO_LUZ: 'Conta de Consumo (Luz)',
  CONTA_CONSUMO_TELEFONE_INTERNET: 'Conta de Consumo (Telefone/Internet)',
  CONTRACHEQUE_HOLERITE: 'Contracheque / Holerite',
  CONTRATO_ALUGUEL: 'Contrato de Aluguel',
  CTPS_FOTO: 'CTPS (Foto)',
  DECLARACAO_RESIDENCIA: 'Declaração de Residência',
  EXTRATO_BANCARIO: 'Extrato Bancário',
  HOLERITE: 'Holerite',
  PASSAPORTE: 'Passaporte',
  RG: 'RG',
};

const UNKNOWN_KEYS = new Set([
  'DESCONHECIDO',
  'INVALID',
  'INVALIDO',
  'NA',
  'NAO_IDENTIFICADO',
  'NAO_INFORMADO',
  'NENHUM',
  'OUTRO',
  'SEM_TIPO',
  'UNKNOWN',
]);

const UNKNOWN_SUBTYPE_KEYS = new Set([
  ...UNKNOWN_KEYS,
  'SEM_SUBTIPO',
  'SUBTIPO_NAO_IDENTIFICADO',
  'SUBTIPO_NAO_INFORMADO',
]);

function normalizeLabelKey(value: unknown): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function humanizeLabelKey(key: string): string {
  return key
    .split('_')
    .filter(Boolean)
    .map((part) => {
      if (part.length <= 3) return part;
      return `${part.charAt(0)}${part.slice(1).toLocaleLowerCase('pt-BR')}`;
    })
    .join(' ');
}

export function formatProcessDocumentTypeLabel(docType: unknown): string {
  const normalized = normalizeLabelKey(docType);
  if (!normalized || UNKNOWN_KEYS.has(normalized)) return UNKNOWN_DOCUMENT_TYPE_LABEL;

  return DOCUMENT_TYPE_LABELS[normalized] ?? humanizeLabelKey(normalized);
}

export function formatProcessDocumentSubtypeLabel(
  docSubtype: unknown,
  docSubtypeText?: unknown
): string {
  const text = typeof docSubtypeText === 'string' ? docSubtypeText.trim() : '';
  if (text && !UNKNOWN_SUBTYPE_KEYS.has(normalizeLabelKey(text))) return text;

  const normalized = normalizeLabelKey(docSubtype);
  if (!normalized || UNKNOWN_SUBTYPE_KEYS.has(normalized)) return UNKNOWN_DOCUMENT_SUBTYPE_LABEL;

  return DOCUMENT_SUBTYPE_LABELS[normalized] ?? humanizeLabelKey(normalized);
}
